import { render, staticRenderFns } from "./ResourceBookmarkItem.vue?vue&type=template&id=23b002e4"
import script from "./ResourceBookmarkItem.ts?vue&type=script&lang=ts&external"
export * from "./ResourceBookmarkItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports